import { Menu, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
// import { ChevronDownIcon } from "@heroicons/react/20/solid";

const FilterDropdown = ({
  filteredOptions,
  selectedValues,
  setSelectedValues,
  searchValue,
  setSearchValue,
}) => {
  const handleFilterSelect = (value) => {
    setSelectedValues(value);
    // onFilterChange(columnId, value); // Pass column ID and selected value to parent
  };
  const { t } = useTranslation();
  return (
    <div className="mb-4 flex justify-end w-full">
      {/* <input
        type="text"
        value={searchValue || ""}
        onChange={(e) => {
          if (e.target.value) {
            setSearchValue(e.target.value);
          } else {
            setSearchValue(null);
          }
        }}
        placeholder={t("navbar.search")}
        className="w-full md:w-1/2 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
      /> */}

      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-8 py-2 text-base font-semibold text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
            {selectedValues || t("common.filter")}
            {/* <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" /> */}
          </Menu.Button>
        </div>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="py-1">
              {filteredOptions.map((option) => (
                <Menu.Item key={option}>
                  {({ active }) => (
                    <button
                      onClick={() => handleFilterSelect(option?.value)}
                      className={`${
                        active ? "bg-gray-100" : ""
                      } w-full text-left px-4 py-2 text-sm text-gray-700`}
                    >
                      {option.label}
                    </button>
                  )}
                </Menu.Item>
              ))}
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => handleFilterSelect("")}
                    className={`${
                      active ? "bg-gray-100" : ""
                    } w-full text-center px-4 py-2 text-sm text-gray-700 border-t`}
                  >
                    {t("common.clearFilter")}
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export default FilterDropdown;
